import React from 'react';
import { InviteCard } from './components/InviteCard';
import { FloatingCrewmates } from './components/FloatingCrewmates';
import './styles/main.scss';

export const App: React.FC = () => {
  return (
    <>
      {/* Space background */}
      <div className="space-background">
        <div className="stars"></div>
        <div className="stars2"></div>
        <div className="stars3"></div>
      </div>

      {/* Floating crewmates */}
      <FloatingCrewmates />

      {/* Main invitation */}
      <InviteCard />
    </>
  );
};